import i18n from '@/i18n'
import { isObjEmpty } from '@/utils/utils'

export default {
    data(): any {
        return {}
    },

    methods: {
        getTranslatedText(text: string, xargs: any = {}) {
            if (!text) {
                return
            }
            const rsText = text.toString().toLowerCase()
            let translatedText: any = i18n.t(rsText.toString())

            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    translatedText = translatedText.replace('[' + key + ']', xargs[key])
                }
            }
            const capitalizedSentence = translatedText.charAt(0).toUpperCase() + translatedText.slice(1)
            return capitalizedSentence
        },

        // Translate a message that came back from an API, where a miss must leave the
        // original text intact. getTranslatedText() cannot be used for this: on a miss
        // i18n.t returns the lowercased key, which would mangle every untranslated
        // backend message. Used for the Ticket Bonus rejection messages.
        translateApiMessage(text: string) {
            if (!text || typeof text !== 'string') {
                return text
            }
            const key = text.toString().toLowerCase()
            return i18n.te(key) ? i18n.t(key) : text
        },
    },
}
